import { genreList } from "../shared/grailConstants";
import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface GenreSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export default function GenreSelect(props: GenreSelectProps) {
  const { isErrored, onChange, readOnly, value, required } = props;

  return (
    <StringFormCombobox
      id="genre-select"
      options={genreList}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
      creatable={{
        // Create only via this row (or Enter while highlighted). Blur reverts —
        // see StringFormCombobox close policy (clearOnBlur).
        formatLabel: (query) => `Other: ${query}`,
      }}
    />
  );
}
